import SubmissionsPage from './SubmissionsPage';

export default SubmissionsPage;